<template>
    <input class="form-check-input">
</template>

<script>
    export default {
        name: 'FormCheckInput'
    }
</script>
